module.exports = __webpack_public_path__ + "media/无基金账户-注册、登录、开户.c51bf90.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/无基金账户-注册、登录、开户.mp4
// module id = DMUq
// module chunks = 3